import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import Navigation from './Navigation';
import { ApplicationState } from '../../../reducers';
import { bindActionCreators } from 'redux';
import { menu } from '../../../actions';
import { ButtonsContainer, LogoContainer } from '../../Layout';

import { Button, Logo, MenuToggle, ProfileCircle } from '..';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavigationItem } from '../../../types/navigation';
import { __ } from '../../../services/translation';

import './Sidebar.scss';

interface Props {
  menuItems: NavigationItem[];
  desktopItems?: NavigationItem[];
  toggled: boolean;
  toggleMenu: () => void;
}

const Sidebar = ({ menuItems, desktopItems, toggled, toggleMenu }: Props) => {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem('sidebar-collapsed') === 'true';
    } catch {
      return false;
    }
  });

  const toggleCollapse = () => {
    const newValue = !collapsed;
    setCollapsed(newValue);
    try {
      localStorage.setItem('sidebar-collapsed', String(newValue));
    } catch { }
  };

  return (
    <>
      <aside className={`sidebar ${toggled ? 'toggled' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-container">
          <div className="sidebar-logo">
            <LogoContainer>
              <Logo />
            </LogoContainer>
          </div>
          <div className="sidebar-toggle">
            <MenuToggle />
          </div>
          <div className="sidebar-circle">
            <ProfileCircle />
          </div>

          <Navigation items={menuItems} desktopItems={desktopItems} collapsed={collapsed} />
          <div className="sidebar-collapse-toggle" onClick={toggleCollapse}>
            <FontAwesomeIcon icon={collapsed ? faChevronRight : faChevronLeft} />
          </div>
        </div>
      </aside>
      <div
        className={`sidebar-shadow ${!toggled ? '' : 'toggled'}`}
        onClick={toggleMenu}
      />
    </>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.details,
  toggled: state.menu.toggled,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({ toggleMenu: menu.toggleMenu }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
